export default __webpack_public_path__ + "static/media/copy-2.17501a29.svg";